import { serverTimestamp } from "firebase/firestore";
import { useEffect, useRef, useState } from "react";
import { Alert, Button, Card } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router";

import { UnauthorizedAccessCollection } from "../../api/firestoreWrappers.generated";
import Layout from "../../components/Layout/Layout";
import { useUser } from "../../contexts/user_provider";
import urls from "../../urls";

export default function UnauthorizedPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const loggedRef = useRef(false);
    const redirectTimeSeconds = 5;

    const [secondsLeft, setSecondsLeft] = useState(redirectTimeSeconds);
    const { user, userClaims } = useUser();

    useEffect(() => {
        if (loggedRef.current) return;
        if (!user || !userClaims) return;

        // Check the actual userClaims to prevent creating documents when admins are testing with custom client role
        if (!userClaims.isAdmin) {
            loggedRef.current = true;

            const data = {
                user: {
                    uid: user.uid,
                    email: user.email,
                },
                timestamp: serverTimestamp(),
                url: location.pathname + location.search + location.hash,
                referrer: document.referrer || null, // Not sure if this does anything
            };

            UnauthorizedAccessCollection().add(data);
        }
    }, [user, userClaims, location]);

    useEffect(() => {
        const interval = setInterval(() => {
            setSecondsLeft((s) => Math.max(s - 1, 0));
        }, 1000);

        const timeout = setTimeout(() => {
            navigate(urls.home(), { replace: true });
        }, redirectTimeSeconds * 1000);

        return () => {
            clearInterval(interval);
            clearTimeout(timeout);
        };
    }, [navigate]);

    return (
        <Layout>
            <title>Unauthorized | MyCorvus</title>
            <Card.Body className="p-4 text-center">
                <h3 className="mb-3">Oops!</h3>
                <Alert variant="warning" className="mb-3">
                    <p className="mb-2">You do not have access to this page.</p>
                    <p className="mb-2">
                        {"We'll take you back home shortly."}
                    </p>

                    <small className="text-muted d-block mb-3">
                        Going to home in {secondsLeft} seconds…
                    </small>

                    <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={() => navigate(urls.home(), { replace: true })}
                    >
                        Go to home now
                    </Button>
                </Alert>
            </Card.Body>
        </Layout>
    );
}
